const Navbar = ({ setView }) => {
  const handleLogin = () => {
    alert('Login feature coming soon! For now, your resume data is saved locally in your browser.');
  };

  return (
    <nav className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 shadow-lg">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-2xl font-bold">Resume Generator</h1>
        <div className="space-x-4">
          <button 
            onClick={() => setView('edit')} 
            className="bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors"
          >
            Edit Resume
          </button>
          <button 
            onClick={handleLogin}
            className="bg-gray-800 text-white px-4 py-2 rounded-lg font-medium hover:bg-gray-700 transition-colors cursor-pointer"
          >
            Login
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;